import { createGenericFormSlice, SliceState } from "./genericFormSlice";

export interface LoginWithPassword {
  password: string | undefined;
}

const formSlice = createGenericFormSlice({
  name: "loginWithPassword",
  initialState: {} as SliceState<LoginWithPassword>,
  reducers: {},
});

export const { reset, initialize, updateField } = formSlice.actions;
const loginWithPasswordFormReducer = formSlice.reducer;
export default loginWithPasswordFormReducer;
